// next-intl integration
export { routing } from './routing';
export type { Locale } from './routing';
export { useI18n, useDirection } from './hooks';
export type { Direction } from './hooks';

// Type helpers (no runtime translations data here — see /messages/*.json)
export {
  getDirection,
  type Language,
  type TranslationKeys,
} from './translations';
